export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  DSPhysicalProduct = 'DSPhysicalProduct',
  DSSquarePayment = 'DSSquarePayment',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
  MaintenanceWork = 'MaintenanceWork',
  AiChat = 'AiChat',
  WebsiteShare = 'WebsiteShare',
  SquarePaymentIntegration = 'SquarePaymentIntegration',
  Helpdesk = 'Helpdesk',
  WhiteLabelRazorpay = 'WhiteLabelRazorpay',
  SubscriptionInvoices = 'SubscriptionInvoices',
  MigrateCustomLoginPage = 'MigrateCustomLoginPage',
  WhiteLabelDeletion = 'WhiteLabelDeletion',
  VatViesBackgroundValidation = 'VatViesBackgroundValidation',
  TransactionalSender = 'TransactionalSender',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
